import { mapGetters, mapState } from 'vuex'
export default {
  computed: {
    ...mapGetters(['configModule', 'hiddenModules']),
    ...mapState({
      // oneBtnZujian46
      oneBtnZujian46: ({ oneBtnZujian46 }) => {
        return oneBtnZujian46
      },
      oldCardTypes: ({ oldCardTypes }) => {
        return oldCardTypes
      },
      selectCard: ({ public: { selectCard } }) => {
        return selectCard
      },
      chekaCardCityName: ({ chekaCardCityName }) => {
        return chekaCardCityName
      },
      // 是否展示 [关于我们]/[联系我们]
    }),
  },
  methods: {
    isShouldDisplay(key) {
      return this.configModule && this.configModule.includes(key)
    },
    isShouldHiddenMd(key) {
      return this.hiddenModules && this.hiddenModules.includes(key)
    },
    moduleShow46() {
      const { oldCardTypes, selectCard, oneBtnZujian46, chekaCardCityName } = this
      if (oneBtnZujian46) return false
      if (chekaCardCityName) {
        return this.isShouldDisplay('46') && oldCardTypes && oldCardTypes.length > 1
      } else {
        return this.isShouldDisplay('46') && oldCardTypes && oldCardTypes.length > 1 && oldCardTypes[oldCardTypes.length - 1].card_type != selectCard.card_type
      }
    },
  },
}
